import { Component } from '@angular/core';
@Component({
  selector: 'loader',
  templateUrl: 'loader.component.html'
})

export class Loader {

  constructor() {
    // console.log("-----------loading-------------")
  }
}


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/loader.component.ts